import { Button, Form, Input, Tooltip, TreeSelect } from 'antd';
import classNames from 'classnames';
import { useEffect, useState } from 'react';
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import PolicyService from '../../../../../services/Policy.service';
import { IconMoveNoBg } from '../../../../workflow/WorkflowDetail/Dnd/iconMove';
import { IconDelete } from './IconDelete';
import { InfoCircleOutlined } from '@ant-design/icons';

const SensitivePersonalData = (props) => {
    const { t } = useTranslation();

    const [selectSenAll, setSelectSenAll] = useState([]);
    const [sensitivePersonalDataOptionList, setSensitivePersonalDataOption] =
        useState([]);
    const [senAddOn, setSenAddOn] = useState('');
    const [error, setError] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');

    const sensitivePersonalDataOption =
        Form.useWatch('sensitivePersonalDataOption', props?.form) ?? [];

    const sensitivePersonalDataOptionSequence =
        Form.useWatch('sensitivePersonalDataOptionSequence', props?.form) ?? [];

    useEffect(() => {
        const getSensitivePersonalDataOption = async () => {
            const { data } =
                await PolicyService.getSensitivePersonalDataOption();
            if (data.resultData) {
                setSensitivePersonalDataOption(data.resultData);
            }
        };
        getSensitivePersonalDataOption();
    }, []);

    const value_ = sensitivePersonalDataOptionList?.map((x) => {
        return {
            title: x.sensitivePersonalDataOptionTh,
            value: x.sensitivePersonalDataOptionId,
        };
    });

    const allIds_ = value_.map(({ value }) => value);

    const reorder = (list, startIndex, endIndex) => {
        const result = Array.from(list);
        const [removed] = result.splice(startIndex, 1);
        result.splice(endIndex, 0, removed);
        return result;
    };

    const onDragPersonalEnd = (result) => {
        // dropped outside the list
        if (!result.destination) {
            return;
        }
        const newItems = reorder(
            sensitivePersonalDataOptionSequence,
            result.source.index,
            result.destination.index
        );
        props.form.setFieldsValue({
            sensitivePersonalDataOptionSequence: newItems,
        });
    };

    const generateObj = (triggerValue) => {
        let personal_ = [];
        personal_ = sensitivePersonalDataOptionList.filter(
            (option) => triggerValue === option.sensitivePersonalDataOptionId
        );
        personal_ = personal_.map((item) => {
            return {
                sensitivePersonDataOptionId: item.sensitivePersonalDataOptionId,
                sensitivePersonDataOptionNameTh:
                    item?.sensitivePersonalDataOptionTh,
                sensitivePersonDataOptionNameEn:
                    item?.sensitivePersonalDataOptionEn ?? '',
                isAddOn: false,
            };
        });
        return personal_[0];
    };

    const generateObjAddOn = (value) => {
        return {
            sensitivePersonDataOptionId: moment().valueOf().toString(),
            sensitivePersonDataOptionNameTh: value,
            sensitivePersonDataOptionNameEn: '',
            isAddOn: true,
        };
    };

    const onChangeSen = (ids, __, { checked, triggerValue }) => {
        setSelectSenAll(ids);
        if (checked) {
            props.form.setFieldsValue({
                sensitivePersonalDataOptionSequence: [
                    ...sensitivePersonalDataOptionSequence,
                    generateObj(triggerValue),
                ],
            });
        }
        if (!checked) {
            props.form.setFieldsValue({
                sensitivePersonalDataOptionSequence:
                    sensitivePersonalDataOptionSequence.filter(
                        (item) =>
                            item.sensitivePersonDataOptionId !==
                            generateObj(triggerValue)
                                .sensitivePersonDataOptionId
                    ),
            });
        }
    };

    const onSelectAllSen = () => {
        setSelectSenAll(allIds_);
        const arr2 = sensitivePersonalDataOptionSequence.map(
            (is) => is.sensitivePersonDataOptionId
        );
        props.form.setFieldsValue({
            sensitivePersonalDataOption: allIds_,
        });
        let temp1 = allIds_.filter((value) => !arr2.includes(value));
        let personal_ = [];
        personal_ = sensitivePersonalDataOptionList.filter((option) =>
            temp1.includes(option.sensitivePersonalDataOptionId)
        );
        personal_ = personal_.map((item) => {
            return {
                sensitivePersonDataOptionId: item.sensitivePersonalDataOptionId,
                sensitivePersonDataOptionNameTh:
                    item?.sensitivePersonalDataOptionTh,
                sensitivePersonDataOptionNameEn:
                    item?.sensitivePersonalDataOptionEn ?? '',
                isAddOn: false,
            };
        });
        props.form.setFieldsValue({
            sensitivePersonalDataOptionSequence: [
                ...sensitivePersonalDataOptionSequence,
                ...personal_,
            ],
        });
    };

    const onUnSelectAllSen = () => {
        setSelectSenAll([]);
        props.form.setFieldsValue({
            sensitivePersonalDataOption: [],
        });
        props.form.setFieldsValue({
            sensitivePersonalDataOptionSequence:
                sensitivePersonalDataOptionSequence.filter((is) => is.isAddOn),
        });
    };

    const onAddSenSequence = (e) => {
        if (senAddOn) {
            const duplicate = sensitivePersonalDataOptionSequence?.find(
                (d) => d.sensitivePersonDataOptionNameTh === senAddOn
            );
            if (duplicate) {
                setError(true);
                setErrorMessage('Duplicate Personal Data');
            } else {
                props.form.setFieldsValue({
                    sensitivePersonalDataOptionSequence: [
                        ...sensitivePersonalDataOptionSequence,
                        generateObjAddOn(senAddOn),
                    ],
                });
                setSenAddOn('');
                setError(false);
            }
        }
        e.preventDefault();
    };

    const removeItemSen = (id) => {
        props.form.setFieldsValue({
            sensitivePersonalDataOptionSequence:
                sensitivePersonalDataOptionSequence.filter(
                    (item) => item.sensitivePersonDataOptionId !== id
                ),
            sensitivePersonalDataOption: sensitivePersonalDataOption.filter(
                (item) => item !== id
            ),
        });
        setSelectSenAll(selectSenAll.filter((item) => item !== id));
    };

    const removeItemAddOnSen = (value) => {
        props.form.setFieldsValue({
            sensitivePersonalDataOptionSequence:
                sensitivePersonalDataOptionSequence.filter(
                    (item) => item.sensitivePersonDataOptionNameTh !== value
                ),
        });
    };

    return (
        <div style={{ background: '#F4F6FC' }} className="p-4 rounded-md mt-4">
            <span className="ant-col ant-form-item-label">
                <label>
                    <span className="text-base font-semibold">
                        {t('policy.sensitivePersonalDataOption')} (
                        {t('TotalItems', {
                            length: sensitivePersonalDataOptionSequence?.length,
                        })}
                        )
                    </span>
                </label>
            </span>

            <div className="grid grid-cols-2 gap-4">
                <div>
                    <label className="text-sm font-semibold">
                        {t('policy.SpecifySensitivePersonalData')}
                    </label>
                    <Form.Item
                        name="sensitivePersonalDataOption"
                        // rules={[
                        //     {
                        //         required: true,
                        //         message: t('errorText.requiredField'),
                        //     },
                        // ]}
                    >
                        <TreeSelect
                            treeCheckable
                            className="tree_ mt-2"
                            size="large"
                            showCheckedStrategy={TreeSelect.SHOW_CHILD}
                            onChange={onChangeSen}
                            placeholder={t('policy.SelectPersonalData')}
                            showSearch={false}
                            maxTagCount={0}
                            maxTagPlaceholder={(omittedValues) =>
                                // `เลือกทั้งหมด ${omittedValues.length} รายการ`
                                `${t('policy.SelectTotalItems', {
                                    length: omittedValues.length,
                                })}`
                            }
                            treeData={[
                                {
                                    title:
                                        selectSenAll?.length ===
                                        value_.length ? (
                                            <button
                                                type="button"
                                                onClick={onUnSelectAllSen}
                                                style={{
                                                    display: 'inline-block',
                                                    color: '#286FBE',
                                                    cursor: 'pointer',
                                                }}
                                            >
                                                {t('dataFlow.UnselectAll')}
                                            </button>
                                        ) : (
                                            <button
                                                type="button"
                                                onClick={onSelectAllSen}
                                                style={{
                                                    display: 'inline-block',
                                                    color: '#286FBE',
                                                    cursor: 'pointer',
                                                }}
                                            >
                                                {t('RoPA.SelectAll')}
                                            </button>
                                        ),
                                    value: 'xxx',
                                    disableCheckbox: true,
                                    disabled: true,
                                    checkable: false,
                                },
                                ...value_,
                            ]}
                        />
                    </Form.Item>
                </div>
                <div>
                    <label className="text-sm font-semibold">
                        {t('policy.CreateAdditionalSensitivePersonalData')}
                    </label>
                    <Form.Item
                        help={error && errorMessage}
                        validateStatus={error && 'error'}
                    >
                        <div className="flex space-x-2 items-center pt-2">
                            <Input
                                onChange={(e) => {
                                    setSenAddOn(e.target.value);
                                    if (e.target.value.length > 300) {
                                        setError(true);
                                        setErrorMessage(
                                            t(
                                                'This field must be between 1 and 300 characters'
                                            )
                                        );
                                    } else setError(false);
                                }}
                                value={senAddOn}
                                size="large"
                                className="bg-white"
                                placeholder={t('policy.AddExampleData')}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        onAddSenSequence(e);
                                    }
                                }}
                                // maxLength={300}
                                // showCount
                            />
                            <Button
                                disabled={error}
                                onClick={onAddSenSequence}
                                size="large"
                                type="primary"
                            >
                                {t('common.Add')}
                            </Button>
                        </div>
                    </Form.Item>
                </div>
            </div>

            <Form.List name="sensitivePersonalDataOptionSequence">
                {(fields) => (
                    <DragDropContext onDragEnd={onDragPersonalEnd}>
                        <Droppable droppableId="droppable">
                            {(provided, snapshot) => (
                                <div ref={provided.innerRef}>
                                    {sensitivePersonalDataOptionSequence?.map(
                                        (item, index) => (
                                            <Draggable
                                                key={
                                                    item.sensitivePersonDataOptionId
                                                }
                                                draggableId={
                                                    item.sensitivePersonDataOptionId
                                                }
                                                index={index}
                                            >
                                                {(provided, snapshot) => (
                                                    <>
                                                        <div
                                                            ref={
                                                                provided.innerRef
                                                            }
                                                            {...provided.draggableProps}
                                                            {...provided.dragHandleProps}
                                                            className={classNames(
                                                                'rounded-md flex justify-between items-center p-4 pr-1 mb-2 h-10 text-sm font-medium cursor-default pl-10 relative bg-white',
                                                                {
                                                                    'bg-purple-light':
                                                                        item.isAddOn,
                                                                }
                                                            )}
                                                        >
                                                            <div className="flex items-center">
                                                                <div className="absolute left-4 top-2">
                                                                    <IconMoveNoBg />
                                                                </div>
                                                                <span>
                                                                    {
                                                                        item.sensitivePersonDataOptionNameTh
                                                                    }
                                                                </span>
                                                            </div>
                                                            <div className="flex items-center space-x-2">
                                                                <Tooltip title="ข้อมูลส่วนบุคคลเพิ่มเติม">
                                                                    <InfoCircleOutlined
                                                                        className="text-purple text-lg cursor-default"
                                                                        hidden={
                                                                            !item.isAddOn
                                                                        }
                                                                    />
                                                                </Tooltip>
                                                                <button
                                                                    type="button"
                                                                    onClick={() =>
                                                                        item.isAddOn
                                                                            ? removeItemAddOnSen(
                                                                                  item.sensitivePersonDataOptionNameTh
                                                                              )
                                                                            : removeItemSen(
                                                                                  item.sensitivePersonDataOptionId
                                                                              )
                                                                    }
                                                                    className="flex items-center"
                                                                >
                                                                    <IconDelete />
                                                                </button>
                                                            </div>
                                                        </div>
                                                        {provided.placeholder}
                                                    </>
                                                )}
                                            </Draggable>
                                        )
                                    )}
                                </div>
                            )}
                        </Droppable>
                    </DragDropContext>
                )}
            </Form.List>
        </div>
    );
};

export default SensitivePersonalData;
